import { AxiosRequestConfig } from 'axios';
import { BASE_API } from '../utils';
import { StudentInKlassBase } from '../../../sdk/src/shared';

export type StudentInClass = StudentInKlassBase;
export type StudentInKlassesIndexResponse = StudentInKlassBase[];

interface ListConfig extends AxiosRequestConfig {
  method: 'GET';
  url: `/classes/${string}/roster`;
}

/**
 * GET /v1/classes/{id}/roster
 */
export const list = (classId: string, lastLogin?: boolean): ListConfig => {
  return {  
    baseURL: BASE_API,
    method: 'GET',
    url: `/classes/${classId}/roster`,
    params: {
      lastLogin
    }
  } as const;
};
